import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import JournalHome from "@/pages/JournalHome";
import JournalLayout from "@/pages/JournalLayout";
import { CurrentIssue, Archive, Announcements } from "@/pages/JournalIssues";
import { JournalAbout, EditorialTeam, Privacy } from "@/pages/JournalAbout";
import Submissions from "@/pages/Submissions";
import JournalContact from "@/pages/JournalContact";
import Information from "@/pages/Information";
import Search from "@/pages/Search";
import { Login, Register } from "@/pages/Account";
import AboutSystem from "@/pages/AboutSystem";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/about/aboutThisPublishingSystem" element={<AboutSystem />} />
          <Route path="/index.php/:slug" element={<JournalLayout />}>
            <Route index element={<JournalHome />} />
            <Route path="issue/current" element={<CurrentIssue />} />
            <Route path="issue/archive" element={<Archive />} />
            <Route path="announcement" element={<Announcements />} />
            <Route path="about" element={<JournalAbout />} />
            <Route path="about/submissions" element={<Submissions />} />
            <Route path="about/editorialTeam" element={<EditorialTeam />} />
            <Route path="about/privacy" element={<Privacy />} />
            <Route path="about/contact" element={<JournalContact />} />
            <Route path="information/:type" element={<Information />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
